import React, {useCallback} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {getPublicProfileStart} from "features/pages/profile-public/reducer";
import {
    publicProfileData,
    publicProfileErrorSelector,
    publicProfileLoading
} from "features/pages/profile-public/selectors";
import {LoadingLogoPortal} from "features/components/loading-logo";
import Text from "features/components/text";
import {Redirect} from "react-router";
import {Icon} from "features/components/icon";
import {__} from "services/i18n";
import Title from "features/components/title";
import {COMPANY_ROLES, OSA_COMMUNITY_WEBSITE} from "constants.js";
import {get} from "lodash";
import Button from "features/components/button";
import {generateFullUrl} from "services/utils/utils";
import Footer from "features/layouts/footer";
import {ReportAProblemButton} from "features/components/problem-button";
import UserProfile from "features/components/user-profile";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: publicProfileLoading(state),
    error: publicProfileErrorSelector(state),
    data: publicProfileData(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getPublicProfileStart
};


export const ProfilePublicPage = (props) => {
    const {getPublicProfileStart} = props;
    const {loading, error, data} = props;

    React.useEffect(() => {
        getPublicProfileStart({slug: props.match.params.slug});
    }, [getPublicProfileStart, props.match.params.slug]);

    const enterOsa = useCallback(() => {
        window.open(OSA_COMMUNITY_WEBSITE, "_blank");
    }, []);

    const renderBook = useCallback(() => {
        const book = data.book;
        if(!book) return null;
        return <div className="book">
            <div>
                <Title size={20}>{__("public-profile.book.title", [{key: "[name]", value: data.profile.firstName}])}</Title>
                <Text size={16}>{__("public-profile.book.text", [{key: "[name]", value: book.title}, {key: "[user_name]", value: data.profile.firstName}])}</Text>
            </div>
            <Button title={__("public-profile.book.button")} onClick={() => window.open(book.link, "_blank")} type={"outlined"} />
            <img src={generateFullUrl(book.image)} alt={"book"}/>
        </div>
    }, [data]);

    const renderContent = useCallback(() => {
        if(loading || !data) {
            return <LoadingLogoPortal />
        }
        if (error.inError) {
            return <Redirect to={"/not-found"} />
        }
        return <div>
            <div className="header">
                <div className="dark" />
                <div className="light">
                    <div className="user-avatar">{data.profile.image ? <img src={generateFullUrl(data.profile.image)} alt="user avatar" /> : <Icon>account-circle</Icon> }</div>
                    <div className="user-name">
                        <Text size={18}>{__("public-profile.community")}</Text>
                        <div>
                            <Title size={48}>{data.profile.firstName} {data.profile.lastName}</Title>
                            {data.companies.length > 0 &&<Text size={18}>{__(get(COMPANY_ROLES.find(i => i.key === data.companies[0].role), 'value', data.companies[0].role))} {__("common.at")} {data.companies[0].name}</Text>}
                        </div>
                    </div>
                </div>
            </div>
            {renderBook()}
            <div className="sidebar-wrapper">
                <div className="content">
                    <UserProfile data={data} />
                </div>
                <div className="sidebar">
                    <div className="white-box enter-osa">
                        <div className="top" />
                        <div className="bottom">
                            <Title size={34} align={"center"}>{__("public-profile.enter-osa.title")}</Title>
                            <Text size={16} align={"center"}>{__("public-profile.enter-osa.text")}</Text>
                            <Button title={__("public-profile.enter-osa.button")} onClick={enterOsa} type={"accent"} icon={"arrow-right"} />
                        </div>
                    </div>
                    <ReportAProblemButton />
                </div>
            </div>
        </div>
    }, [data, enterOsa, error.inError, loading, renderBook]);


    return <div className="profile-public-page">
        {renderContent()}
        <Footer type={"light"} />
    </div>
};
export default connect(mapStateToProps, mapDispatchToProps)(ProfilePublicPage);